/* eslint-disable camelcase */
import Model from '../../../Api/Models/Model';
import GetCasinoGameResponse from '../CRM/Responses/CasinoGameResponse';

export default class CasinoGame extends Model {
    readonly id: number;
    readonly casino_provider_id: number;
    readonly casino_game_category_id: number | null;
    readonly casino_game_seo_tag_id: number | null;
    readonly uuid: string;
    readonly name: string;
    readonly slug: string;
    readonly image: string | null;
    readonly image_path: string | null;
    readonly image_url: string;
    readonly type: string;
    readonly creator_name: string;
    readonly technology: string;
    readonly has_demo: boolean;
    readonly has_lobby: boolean;
    readonly has_freespins: boolean;
    readonly is_deleted: boolean;
    readonly is_mobile: boolean;
    readonly is_desktop: boolean;
    readonly is_freespin_valid_until_full_day: boolean;
    readonly is_disabled: boolean;
    readonly is_health_check_passed: boolean;
    readonly last_health_check_date: Date | null;
    readonly rtp: number | null;
    readonly updated_at: string;
    readonly created_at: string;

    constructor(casinoGame: Partial<GetCasinoGameResponse>) {
        super();
        this.assignDataToProps(casinoGame, [
            'id',
            'casino_provider_id',
            'casino_game_category_id',
            'uuid',
            'name',
            'slug',
            'image',
            'image_path',
            'image_url',
            'type',
            'creator_name',
            'technology',
            'has_demo',
            'has_lobby',
            'has_freespins',
            'is_deleted',
            'is_mobile',
            'is_desktop',
            'is_freespin_valid_until_full_day',
            'is_disabled',
            'is_health_check_passed',
            'last_health_check_date',
            'rtp',
            'updated_at',
            'created_at',
        ]);
    }
}

export enum CasinoGameDeviceType {
    DESKTOP = 'desktop',
    MOBILE = 'mobile',
}
